import type { Room } from "../../../interfaces/interfaces";

export default [
  {
    name: "I101",
    id: "0237b71d-559b-4f14-ba61-521466a69b4f",
  },
  {
    name: "I205",
    id: "6402a119-72a8-48d9-bb89-22ce44572ff8",
  },
  {
    name: "I206",
    id: "4e8f8b40-6282-4da5-bd73-ddbab271f545",
  },
  {
    name: "I102",
    id: "d4b646f4-2b10-46d9-9410-cc8564d14be9",
  },
  {
    name: "IG10",
    id: "0a1f508f-b4bc-4ef0-b330-43b22c08f583",
  },
  {
    name: "IG11",
    id: "3597629d-d984-47a4-8bb0-59cc7e6e2d84",
  },
  {
    name: "IG12",
    id: "0d502e8c-0e5f-4f19-ab9b-346a26235bb2",
  },
  {
    name: "IG13",
    id: "e6ae403e-b00c-43cf-ae69-a5e557963999",
  },
  {
    name: "IG14",
    id: "070c3a08-602f-4818-8ac4-4316eade50ff",
  },
  {
    name: "IG15",
    id: "4212d75d-bf1e-4036-8db1-9b5cce6ac7e7",
  },
  {
    name: "IG16",
    id: "93d00218-eff0-4072-85b8-d76182472002",
  },
  {
    name: "IG17",
    id: "8823cdad-5995-402c-be2f-ee589c1a9234",
  },
  {
    name: "IG20",
    id: "162cd498-fcec-4b96-8684-06a4c3b40e78",
  },
  {
    name: "IG21",
    id: "3f1a50c0-ce82-4b06-a738-f516f026d087",
  },
  {
    name: "I-fiket",
    id: "03dd5bc2-a10c-4db8-9e9f-52f72a0fb5c9",
  },
] as Room[];
